import { getUserID } from "../Utility/service";
import { SLACK_KEY_SLUG, SLACK_USER_BASED_KEY_SLUG } from "../constants/Api_constants";
import { axiosSecureInstance } from "./axios";

const userId = getUserID();

export const storeSlackKeyToDB = async ({ memberId, oauthToken }) => {
    const body = {
        userId,
        memberId,
        oauthToken,
    };
    const response = await axiosSecureInstance.post(SLACK_KEY_SLUG, body);
    return response;
};

export const deleteSlackAccessKeyFromDB = async () => {
    const responseOfSlackKeyDelete = await axiosSecureInstance.delete(SLACK_USER_BASED_KEY_SLUG(userId));
    return responseOfSlackKeyDelete;
};

export const getSlackCredentials = async (setIsSlackConnected) => {
    const slackCredential = userId? await axiosSecureInstance.get(SLACK_USER_BASED_KEY_SLUG(userId)): null;
    if (slackCredential?.data?.getSlackCredential?.accessToken) {
        setIsSlackConnected(true);
    } else {
        setIsSlackConnected(false);
    }
    return slackCredential;
};